import React from 'react';
import { Form } from 'react-bootstrap';

const RadioCard = (props) => {
  return (
    <div className='card my-1'>
      <div className='card-body py-2'>
        <Form.Check type='radio' id={props.id} label={props.label} {...props} />
      </div>
    </div>
  );
};

export default RadioCard;
